import dayjs from "@/lib/dayjs";
import { getMonthRange } from "@/lib/dayjs/get-month-range";
import { getMonthRangeByDate } from "@/lib/dayjs/get-month-range-by-date";
import { LangCode } from "@/lib/gql/__generated__/graphql";

import { createCurrentMonthDays, createNextMonthDays, createPreviousMonthDays } from "./create-calendar-days";
import { createDayOfWeekArray } from "./create-day-of-week-array";

import type { CalendarDayArrayType, CalendarType } from "./types";

export type { CalendarDayType } from "./types";

/**
 * 操作日の月の日付の配列を取得する
 */
export function createCalendarData({
	initialDate,
	lang = LangCode.Default,
	numberOfMonths,
}: {
	initialDate?: string;
	lang?: LangCode;
	numberOfMonths: number;
}): CalendarType {
	const { firstDay, lastDay } = initialDate ? getMonthRangeByDate(initialDate) : getMonthRange();

	const daysOfMonth: CalendarType["daysOfMonth"] = Array.from({ length: numberOfMonths }, (_, i) => {
		const dayjsFirstDay = dayjs(firstDay).add(i, "month").startOf("month");
		const dayjsLastDay = dayjs(lastDay).add(i, "month").endOf("month");

		return {
			month: dayjsFirstDay.format("YYYY年 M月"),
			firstDay: dayjsFirstDay.format("YYYY-MM-DD"),

			days: [
				...createPreviousMonthDays(dayjsFirstDay, lang),
				...createCurrentMonthDays(dayjsFirstDay, dayjsLastDay, lang),
				...createNextMonthDays(dayjsLastDay, lang),
			] satisfies CalendarDayArrayType,
		};
	});

	return {
		currentMonthFirstDay: firstDay,
		dayOfWeekArray: createDayOfWeekArray(lang),
		daysOfMonth,
	};
}
